import React from "react";
import { Form } from "./components/Form";
import { Container } from "./components/Context/Container";
import "./App.scss";

export const App = () => {
  return (
    <Container>
      <Form />
    </Container>
  );
};
